<template>
  <div class="zteContainer">
    <div class="ztePanel">
      <div class="ztePanelHeader">
        <div class="lineHeader" v-if="panelMode == 'normal'">
          <div class="leftH title">云联络中心</div>
          <div class="leftR titleBtns">
            <Icon @click="()=>{panelMode = 'mini'}" class="pointer" type="ios-contract" />
          </div>
        </div>
        <div class="lineHeader">
          <div class="leftH">
            <Dropdown @on-click="changeStatus" transfer transfer-class-name="statusMenu">
              <!-- <template v-if="operatorStatus == 'online'">
                  <span class="status online"></span>在线
              </template>-->
              <template v-if="operatorStatus == 'offline'">
                <span class="status offline"></span>离线
              </template>
              <!-- <template v-if="operatorStatus == 'sleep'">
                <span class="status sleep"></span>小休
              </template>-->
              <template v-if="operatorStatus == 'idle'">
                <span class="status idle"></span>在线
              </template>
              <template v-if="operatorStatus == 'busy'">
                <span class="status busy"></span>示忙
              </template>
              <Icon type="ios-arrow-down"></Icon>

              <DropdownMenu slot="list">
                <!-- <DropdownItem name="online">
                    <span class="status online"></span>在线
                </DropdownItem>-->
                <DropdownItem name="offline">
                  <span class="status offline"></span>离线
                </DropdownItem>

                <DropdownItem name="idle" v-if="btnMaps.btnSetIdle.show">
                  <span class="status idle"></span>示闲
                </DropdownItem>
                <DropdownItem name="busy" v-if="btnMaps.btnSetBusy.show">
                  <span class="status busy"></span>示忙
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <template v-if="panelMode == 'normal'">
            <div class="leftC"></div>
            <div class="rightH">
              <div>{{stateMap[currentStatus]}}</div>
            </div>
          </template>
          <template v-else>
            <div class="centerH">
              <template v-if="canCall">
                <Input clearable placeholder="请输入需要拨打的号码" v-model="calleeNumber" />
                <Button
                  :disabled="calleeNumber.length > 0?false:true"
                  @click="clickMakeCall"
                  icon="md-call"
                  type="success"
                ></Button>
              </template>
            </div>
            <div class="rightH titleBtns">
              <Icon @click="()=>{panelMode = 'normal'}" class="pointer" type="ios-expand" />
            </div>
          </template>
        </div>
      </div>
      <template v-if="panelMode == 'normal'">
        <div class="ztePanelBody">
          <template v-if="['online', 'idle'].indexOf(operatorStatus) >= 0">
            <div class="numberPanel" v-if="viewModel == 'numberPanel'">
              <Input clearable placeholder="请输入需要拨打的号码" size="large" v-model="calleeNumber" />
              <div class="phoneContainer">
                <div :key="i+'-line'" class="line" v-for="i in 3">
                  <div
                    :class="{'numBtn':true, 'disabled': operatorStatus=='online'}"
                    :key="i+'-'+num"
                    @click="addNumber((i -1) * 3 + num)"
                    v-for="num in 3"
                  >{{(i -1) * 3 + num}}</div>
                </div>
                <div class="line">
                  <div @click="addNumber('*')" class="numBtn">*</div>
                  <div @click="addNumber('0')" class="numBtn">0</div>
                  <div @click="addNumber('#')" class="numBtn">#</div>
                </div>

                <div class="phoneBtns">
                  <div>
                    <Tooltip content="通话记录" v-if="options.params.canViewHis">
                      <Button
                        @click="showHistory"
                        icon="md-menu"
                        shape="circle"
                        size="large"
                        type="text"
                      ></Button>
                    </Tooltip>
                  </div>
                  <div>
                    <Button
                      :disabled="calleeNumber.length > 0?false:true"
                      @click="clickMakeCall"
                      icon="md-call"
                      shape="circle"
                      size="large"
                      style="width: 56px;height: 56px"
                      type="success"
                    ></Button>
                  </div>
                  <div>
                    <Tooltip content="操作记录">
                      <Button
                        @click="showOPHis"
                        icon="md-clipboard"
                        shape="circle"
                        size="large"
                        type="text"
                      ></Button>
                    </Tooltip>
                    <!-- <Button
                    @click="showHistory"
                    icon="md-keypad"
                    shape="circle"
                    size="large"
                    type="text"
                    ></Button>-->
                  </div>
                </div>
              </div>
            </div>
            <div class="hisPanel" v-else-if="viewModel=='history'">
              <div class="historyHeader">
                <Icon @click="backPanel" class="backBtn" type="md-arrow-round-back" />通话记录(仅显示近3天记录)
              </div>
              <div class="historyRecordList">
                <div class="loadingC" v-if="loadingHis">
                  <Spin v-if="loadingHis">加载中...</Spin>
                </div>
                <template v-else>
                  <template v-if="historyRecords && historyRecords.length > 0">
                    <div
                      :key="idx+'-his'"
                      class="historyRecord"
                      v-for="(item, idx) in historyRecords"
                    >
                      <div @click="loadCallRecord(item)">
                        <div class="historyRecordTitle">
                          <template v-if="item.callType == 'INBOUND'">
                            <svg
                              class="icon"
                              height="20"
                              p-id="1070"
                              t="1754034495401"
                              version="1.1"
                              viewBox="0 0 1024 1024"
                              width="20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M665.4 679c2.3 0.9 54.4 22.3 96.9 52.5 16 11.5 42.8 30.6 47.2 57.8 2.8 18.6-4.3 39.1-21.7 62.8-4.3 6.1-43.1 58.7-117.6 72.7-20.5 3.9-42.1 4.6-64.2 2.1-23.2-2.5-47.6-8.6-72.1-18.2-96.6-35.3-175.9-89.3-257.6-175C136 586.5 106.9 443.1 102.6 415.9c-22.4-125.1 72.6-194 83.5-201.5 14.9-10.6 28.5-17 41.5-19.5 3.5-0.7 7.7-1.1 12-1.1 2.3 0 4.5 0.1 6.7 0.3 11.9 1.4 29.4 7.4 44.2 28.6 20.2 28.8 42.2 71.3 60.1 116.9 18.7 47.2-6.1 66.1-30.2 84.4l-1 0.6s-43.3 28.5-51 33.4c-7.5 4.9-10.1 14.9-5.7 22.7 29.3 53.9 68.9 108.2 114.6 156.8 45 47.8 95.8 90.2 147 122.5 2.6 1.7 5.8 2.6 9.2 2.6 1 0 2.1-0.1 3.1-0.3l1.4-0.4c5.1-1.5 9.2-5.1 11.1-9.8 4.9-9.5 13.5-24.8 23.1-38 18.1-25 36.1-38.8 54.9-42.4 2.9-0.6 6.4-0.9 9.8-0.9 2.1 0 4.1 0.1 6.1 0.3 4.5 1.2 12.8 3.8 22.4 7.9z"
                                fill="#2d8cf0"
                                p-id="1071"
                              />
                              <path
                                d="M515 427.4l202.7-176.9c8.6-7.6 21.9-6.7 29.4 2l54.9 62.9c7.6 8.6 6.7 21.9-2 29.4L597.1 521.6c-8.6 7.6-21.9 6.7-29.4-2l-54.9-62.9c-7.4-8.6-6.5-21.7 2.2-29.3z"
                                fill="#2d8cf0"
                                p-id="1072"
                              />
                              <path
                                d="M716.5 544.6L488.3 543c-18.7 2.8-33.7-15.4-27.3-33.3l44.7-205.3c6.5-17.8 29.7-22.3 42.3-8.1l183.5 207.1c13.3 14.8 4.7 38.3-15 41.2z"
                                fill="#2d8cf0"
                                p-id="1073"
                              />
                            </svg>
                            {{item.caller | desensitizedPhone}}
                          </template>
                          <template v-else-if="item.callType == 'OUTBOUND'">
                            <svg
                              class="icon"
                              height="20"
                              p-id="10413"
                              t="1754033914057"
                              version="1.1"
                              viewBox="0 0 1024 1024"
                              width="20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M665.4 679c2.3 0.9 54.4 22.3 96.9 52.5 16 11.5 42.8 30.6 47.2 57.8 2.8 18.6-4.3 39.1-21.7 62.8-4.3 6.1-43.1 58.7-117.6 72.7-20.5 3.9-42.1 4.6-64.2 2.1-23.2-2.5-47.6-8.6-72.1-18.2-96.6-35.3-175.9-89.3-257.6-175C136 586.5 106.9 443.1 102.6 415.9c-22.4-125.1 72.6-194 83.5-201.5 14.9-10.6 28.5-17 41.5-19.5 3.5-0.7 7.7-1.1 12-1.1 2.3 0 4.5 0.1 6.7 0.3 11.9 1.4 29.4 7.4 44.2 28.6 20.2 28.8 42.2 71.3 60.1 116.9 18.7 47.2-6.1 66.1-30.2 84.4l-1 0.6s-43.3 28.5-51 33.4c-7.5 4.9-10.1 14.9-5.7 22.7 29.3 53.9 68.9 108.2 114.6 156.8 45 47.8 95.8 90.2 147 122.5 2.6 1.7 5.8 2.6 9.2 2.6 1 0 2.1-0.1 3.1-0.3l1.4-0.4c5.1-1.5 9.2-5.1 11.1-9.8 4.9-9.5 13.5-24.8 23.1-38 18.1-25 36.1-38.8 54.9-42.4 2.9-0.6 6.4-0.9 9.8-0.9 2.1 0 4.1 0.1 6.1 0.3 4.5 1.2 12.8 3.8 22.4 7.9z"
                                fill="#2d8cf0"
                                p-id="10414"
                              />
                              <path
                                d="M751.6 362.6L548.9 539.5c-8.6 7.6-21.9 6.7-29.4-2l-54.9-62.9c-7.6-8.6-6.7-21.9 2-29.4l202.8-176.9c8.6-7.6 21.9-6.7 29.4 2l54.9 62.9c7.5 8.7 6.5 21.8-2.1 29.4z"
                                fill="#2d8cf0"
                                p-id="10415"
                              />
                              <path
                                d="M550.1 245.4l228.2 1.7c18.7-2.8 33.7 15.4 27.3 33.3l-44.7 205.3c-6.5 17.8-29.7 22.3-42.3 8.1L535.1 286.7c-13.3-14.9-4.7-38.4 15-41.3z"
                                fill="#2d8cf0"
                                p-id="10416"
                              />
                            </svg>
                            {{item.callee | desensitizedPhone}}
                          </template>
                        </div>
                        <div class="historyRecordTime">{{item.startTime}}</div>
                      </div>
                      <div
                        class="historyRecordBtns"
                        v-if="['INBOUND', 'OUTBOUND'].indexOf(item.callType) >=0"
                      >
                        <div @click="callP(item)" class="callBtn">
                          <Icon type="ios-call" />
                        </div>
                        <!-- <div class="moreBtn">
                    <Icon type="md-more" />
                        </div>-->
                      </div>
                    </div>

                    <div class="textR">
                      <Page :total="historyRecordTotal" @on-change="pageChange" size="small" />
                    </div>
                  </template>
                  <div class="nodata" v-else>暂无数据</div>
                </template>
              </div>
            </div>
            <div class="hisPanel" v-else-if="viewModel=='opHis'">
              <div class="historyHeader">
                <Icon @click="backPanel" class="backBtn" type="md-arrow-round-back" />操作记录(仅显示本次记录)
              </div>
              <div class="historyRecordList" v-if="messageList && messageList.length > 0">
                <Timeline>
                  <TimelineItem
                    :color="item.status == 'error'?'red':'green'"
                    :key="idx+'-log'"
                    v-for="(item, idx) in messageList"
                  >
                    <p class="time">{{item.time}}</p>
                    <p class="content">{{item.message}}</p>
                  </TimelineItem>
                </Timeline>
              </div>
            </div>
            <div class="telRingPanel" v-else-if="viewModel == 'telRingPanel'">
              <template v-if="currentCallType == 'INBOUND'">
                <!-- 呼入 -->
                <div class="telPanelHeader">来电号码 | {{callingLocation || '未知' }}</div>
                <div class="telNumber">{{recordInfo.caller | desensitizedTelNum}}</div>
                <div class="telTime">{{telTime}}</div>
                <Divider dashed>来电信息</Divider>
                <div class="telRingInfo">
                  <div>
                    <div class="telRingLabel">48小时来电次数</div>
                    <div class="telRingValue">{{nearlyCallInfo?.times || '--'}}</div>
                  </div>
                  <div>
                    <div class="telRingLabel">上次来电时间</div>
                    <div class="telRingValue">{{nearlyCallInfo?.lastDateTime || '--'}}</div>
                  </div>
                  <div>
                    <div class="telRingLabel">被叫号码</div>
                    <div class="telRingValue">{{recordInfo.callee || '--'}}</div>
                  </div>
                </div>
              </template>
              <template v-else-if="currentCallType == 'OUTBOUND'">
                <!-- 呼出 -->
                <div class="telPanelHeader">去电号码 | {{callingLocation || '未知' }}</div>
                <div class="telNumber">{{recordInfo.callee | desensitizedTelNum}}</div>
                <div class="telTime">{{telTime}}</div>
                <Divider dashed>去电信息</Divider>
                <div class="telRingInfo">
                  <div>
                    <div class="telRingLabel">48小时去电次数</div>
                    <div class="telRingValue">{{nearlyCallInfo?.times || '--'}}</div>
                  </div>
                  <div>
                    <div class="telRingLabel">上次去电时间</div>
                    <div class="telRingValue">{{nearlyCallInfo?.lastDateTime || '--'}}</div>
                  </div>
                  <div>
                    <div class="telRingLabel">主叫号码</div>
                    <div class="telRingValue">{{recordInfo.caller || '--'}}</div>
                  </div>
                </div>
              </template>
              <div class="btnContainer">
                <div class="answerBtn" v-if="312 == currentStatus">
                  <Tooltip content="接听">
                    <Button
                      @click="answerTel"
                      icon="md-call"
                      shape="circle"
                      size="large"
                      style="width: 56px;height: 56px"
                      type="success"
                    ></Button>
                  </Tooltip>
                </div>

                <div
                  class="answerBtn"
                  v-if="(currentCallType == 'OUTBOUND' && (currentStatus == 313 || (currentStatus >= 300 && currentStatus<= 310) ))|| (currentCallType == 'INBOUND' && options.params.canHangUp && (currentStatus == 312 || (currentStatus >= 300 && currentStatus<= 310)))"
                >
                  <Tooltip content="挂断">
                    <Button
                      @click="clickHangup"
                      icon="md-call"
                      shape="circle"
                      size="large"
                      style="width: 56px;height: 56px"
                      type="error"
                    ></Button>
                  </Tooltip>
                </div>

                <template v-if="currentStatus == 400 || currentStatus == 401">
                  <div class="answerBtn">
                    <Button
                      @click="cancelAdjust()"
                      icon="md-call"
                      shape="circle"
                      size="large"
                      style="width: 56px;height: 56px"
                      type="success"
                    ></Button>
                    <p class="btnDesc">开始接听({{handlerSec}}秒)</p>
                  </div>

                  <div class="answerBtn">
                    <Button
                      @click="adjust()"
                      icon="md-create"
                      shape="circle"
                      size="large"
                      style="width: 56px;height: 56px"
                      type="default"
                    ></Button>
                    <p class="btnDesc">话后处理</p>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <template v-else-if="['busy'].indexOf(operatorStatus) >= 0">
            <div class="ztePanelOnline">
              <p>
                <Icon color="#ff9900" size="20" type="md-information-circle" />当前示忙，电话无法接入
              </p>
            </div>
            <!-- 示忙 -->
            <div class="textC">
              <Button
                :disabled="btnMaps.btnSetIdle.disabled"
                @click="changeStatus('idle')"
                type="primary"
              >立即示闲</Button>
              <Button
                :disabled="btnMaps.btnSignOut.disabled"
                @click="changeStatus('offline')"
                type="error"
              >立即下线</Button>
            </div>
          </template>
          <template v-else>
            <!-- 离线 -->
            <div class="ztePanelOff">
              <p>
                <Icon color="#ff9900" size="20" type="md-information-circle" />您尚未开始工作
              </p>
            </div>
            <div class="textC">
              <Button @click="clickBtnSignIn" type="primary">立即上线</Button>
            </div>
          </template>
        </div>
      </template>
    </div>
    <div class="loginLoading" v-if="loginLoading">
      <Spin fix>
        <Icon class="loadingIcon" size="20" type="ios-loading"></Icon>
        <div>签入中...</div>
      </Spin>
    </div>
  </div>
</template>
<script>
// import "./zte/js/jquery-1.8.3.min.js"
export default {
  props: {
    options: {
      required: true
    }
  },
  data () {
    // 零配置地址、工号、虚拟中心、密码
    // var zeroCfgURL, operatorId, vcid, password, md5Util = MD5()
    return {
      checkHeartTimer: null,
      phonePre: '999',
      currentSerialNum: null,
      nearlyCallInfo: null,
      loginLoading: false,
      registerAgentEventsIds: [],
      operatorStatus: 'offline',
      panelMode: 'normal', // normal mini
      viewModel: 'numberPanel',// numberPanel  history telRingPanel
      // 去电号码
      calleeNumber: '',
      // 来电号码
      callingNumber: '15800000000',
      telTime: '',
      callingLocation: '',
      currentCallType: 'OUTBOUND',
      currentUser: null,
      lastStatus: 0,
      currentStatus: 0,
      statusLabel: '',
      calldata: '',
      // 计时器，大于0表示正在计时
      timerBegin: 0,
      timerid: null,

      // 录音记录相关信息
      recordInfo: {},
      soundRecording: {},

      // 座席状态表
      stateMap: {
        // AgentNull
        0: "未登录",
        1: "注销",
        2: "下班 ",
        3: "系统自动签出",
        4: "强制注销",

        // AgentNotReady	
        100: "登录",
        101: "上班",
        102: "离席",
        103: "锁定",
        104: "强制被锁定",
        105: "示忙",
        106: "强制被示忙 ",
        107: "预呼",
        108: "媒体处理",
        109: "质检",
        110: "WEBCALL",
        111: "学习状态",
        // AgentReady
        200: "示闲",
        201: "强制示闲",
        202: "主动示闲",
        203: "系统自动示闲",
        204: "强拆",
        // AgentBusy
        300: "接入用户通话",
        301: "内部呼入通话",
        302: "外部呼出通话",
        303: "内部呼出通话",
        304: "保持",
        305: "会议",
        306: "外部咨询",
        307: "内部咨询",
        308: "远端咨询状态",
        309: "插话",
        310: "监听",
        312: "呼入振铃态。",
        313: "呼出振铃态。",
        314: "排队选中，等待呼入",
        315: "CTI选中，等待呼入",
        316: "业务占用，等待座席呼出",
        317: "教练状态(发起者)",
        380: "联席会议状态",
        381: "高达通话状态",
        // AgentWorkAfter
        400: "自动进入事后处理状态",
        401: "手工进入事后处理状态"
      },
      callTypes: {
        INBOUND: "呼入",
        INTERNAL: "内部通话",
        OUTBOUND: "呼出",
        PREDICTIVE: "预测式外呼",
        BACK2BACK: "双呼",
        BARGE: "强插",
        INTERCEPT: "强拆",
        CONSULTANT: "咨询",
        CONFERENCE: "会议",
        PRIVACYDIAL: "加密通话",
        MONITOR: "监听"
      },
      // 目标号码类型正则表达式，需要根据实际工程规划情况修改。
      targetNoType: {
        "voipPhone": /^[56](\d){5}$/, //ip电话. 例如，5或者6开头的6位数字
        "sipPhone": /^3(\d){5}$/, //sip电话。例如，3开头的6位数字
        //工号，8开头的6位数字
        "agtId": /^8(\d){5}$/,
        //5 8034开头
        "ivrCode": /^8034(\d)*$/,
        //技能号, 1~999
        "skill": /^[1-9]{1}|[1-9]{1}[0-9]{1}|[1-9]{1}[0-9]{1}[1-9]{1}$/,
        //外部电话号码 0开头的号码
        "usrPhone": /^((999)|(86)|(0))?1[0-9]{10}$/,
        "usrTel": /^[0](\d)+$/
      },
      loginInfo: {
        operatorId: null,
        password: null,
        // 0 软电话  2 PC+PHONE
        phoneType: '0',
        mobile: null,
        // 媒体类型 1 音频 2视频
        mediaType: '1',
      },
      messageList: [],
      historyRecordTotal: 100,
      loadingHis: false,
      historyRecords: [
        {
          caller: 'xxxxx',
          callee: 'xxxx',
          callTime: 'xxxx-nn-mm hh:mm:ss',
          callType: 'INBOUND'
        },
        {
          caller: 'xxxxx',
          callee: 'xxxx',
          callTime: 'xxxx-nn-mm hh:mm:ss',
          callType: 'OUTBOUND'
        }
      ],
      handlerSec: 60,
      handlerTimer: null,
      type: '',
    }
  },
  computed: {
    baseURL: function () {
      return this.$store.getters['systemSupport/systemSupport']?.HL || process.env.VUE_APP_API_ROOT
    },
    hlLawyerStatus: function () {
      let status = this.$store.getters['lawyerInfo/lawyerStatus']['HL_FP']
      return status
    },
    btnMaps: function () {
      let that = this
      return {
        btnSignIn: {
          disabled: that.currentStatus >= 100 ? true : false,
          label: '登录',
          show: true,
          type: 'primary'
        },
        btnSignOut: {
          disabled: that.currentStatus >= 100 ? false : true,
          label: '签出',
          show: true,
          type: 'primary'
        },
        btnSetIdle: {
          disabled: (that.currentStatus >= 105 && that.currentStatus < 108) || that.currentStatus == 111 || that.currentStatus == 317
            || (that.currentStatus >= 400 && that.currentStatus < 500) ? false : true,
          label: '示闲',
          show: (that.currentStatus >= 105 && that.currentStatus < 108) || that.currentStatus == 111 || that.currentStatus == 317
            || (that.currentStatus >= 400 && that.currentStatus < 500) ? true : false,
          type: 'primary'
        },
        btnSetBusy: {
          disabled: (that.currentStatus >= 200 && that.currentStatus < 300) || that.currentStatus == 108 || that.currentStatus == 109
            || (that.currentStatus >= 400 && that.currentStatus < 500) ? false : true,
          label: '示忙',
          show: (that.currentStatus >= 200 && that.currentStatus < 300) || that.currentStatus == 108 || that.currentStatus == 109
            || (that.currentStatus >= 400 && that.currentStatus < 500) ? true : false,
          type: 'primary'
        },
        btnHangup: {
          disabled: that.currentStatus >= 300 && that.currentStatus <= 313 ? false : true,
          label: '挂机',
          show: true,
          type: 'primary'
        },
        btnHold: {
          disabled: that.currentStatus == 300 || that.currentStatus == 302 ? false : true,
          label: '保持',
          show: that.currentStatus == 300 || that.currentStatus == 302 ? true : true,
          type: 'primary'
        },
        btnCancelHold: {
          disabled: that.currentStatus == 304 ? false : true,
          label: '取消保持',
          show: that.currentStatus == 304 ? true : true,
          type: 'primary'
        },
        btnMakeCallAgt: {
          disabled: (that.currentStatus >= 200 && that.currentStatus < 300) || that.currentStatus == 105 || that.currentStatus == 106
            || that.currentStatus == 304 || that.currentStatus == 310 || (that.currentStatus >= 400 && that.currentStatus < 500) ? false : true,
          label: '外呼',
          show: true,
          type: 'primary'
        },
        btnTransfer: {
          disabled: that.currentStatus >= 306 && that.currentStatus <= 308 ? false : true,
          label: '转移',
          show: that.currentStatus >= 306 && that.currentStatus <= 308 ? true : false,
          type: 'primary'
        },
        btnSingleStepTransfer: {
          disabled: that.currentStatus >= 300 && that.currentStatus <= 303 ? false : true,
          label: '单步转',
          show: true,
          type: 'primary'
        },
        btnConference: {
          disabled: (that.currentStatus >= 305 && that.currentStatus <= 308) || (that.currentStatus >= 300 && that.currentStatus <= 303) ? false : true,
          label: '会议',
          show: true,
          type: 'primary'
        },
        btnCancel: {
          disabled: that.currentStatus == 304 ? false : true,
          label: '接回',
          show: that.currentStatus == 304 ? true : false,
          type: 'primary'
        },
        btnConsultIVR: {
          disabled: that.currentStatus == 300 || that.currentStatus == 302 ? false : true,
          label: '咨询IVR验证',
          show: true,
          type: 'primary'
        },
        btnTransferIVR: {
          disabled: that.currentStatus >= 300 && that.currentStatus <= 303 ? false : true,
          label: '挂机转回IVR',
          show: true,
          type: 'primary'
        },
        btnConsultAgt: {
          disabled: that.currentStatus == 300 || that.currentStatus == 302 ? false : true,
          label: '咨询',
          show: true,
          type: 'primary'
        },

        btnAlternate: {
          disabled: that.currentStatus >= 306 && that.currentStatus <= 308 ? false : true,
          label: '切换',
          show: that.currentStatus >= 306 && that.currentStatus <= 308 ? true : false,
          type: 'primary'
        },
        btnSetCallData: {
          disabled: that.currentStatus >= 300 && that.currentStatus <= 313 ? false : true,
          label: '设置随路数据',
          show: true,
          type: 'primary'
        },
        btnHangupMyself: {
          disabled: that.currentStatus >= 300 && that.currentStatus <= 313 ? false : true,
          label: '挂自己',
          show: true,
          type: 'primary'
        },
        // 班长管理按钮
        btnListen: {
          disabled: true,
          label: '监听',
          show: true,
          type: 'primary'
        },
        btnInsert: {
          disabled: true,
          label: '插话',
          show: true,
          type: 'primary'
        },
        btnForceIdle: {
          disabled: true,
          label: '强闲',
          show: true,
          type: 'primary'
        },
        btnForceClear: {
          disabled: true,
          label: '强拆',
          show: true,
          type: 'primary'
        },
        btnForceOut: {
          disabled: true,
          label: '离线',
          show: true,
          type: 'primary'
        },
        btnSetBuffer: {
          disabled: true,
          label: '设置缓存',
          show: true,
          type: 'primary'
        },
        btnGetByuffer: {
          disabled: true,
          label: '获取缓存',
          show: true,
          type: 'primary'
        },
      }
    },
    canCall: function () {
      return (this.currentStatus >= 200 && this.currentStatus < 300)
    }
  },
  methods: {
    /**
    * 通话呼入振铃事件
    * 1.有呼叫呼入座席时，触发本事件。
    * 2.座席呼出/咨询/单步会议时，发起操作的座席收到该事件。
    * @param calling 主叫号码
    * @param callee 被叫号码
    * @param callid 呼叫ID
    * @param calldata 随路数据
    * @param correlatedata 扩展随路数据，字符串类型，键值对方式 
    * 						CALLINGOBJ=X/Y/Z;
    * 						主叫是座席：X为0；Y为主叫电话号码；Z为座席工号。
    * 						主叫是用户：X为1；Y为主叫电话号码；Z为空字符串。
    * 						主叫是在线客服用户：X为2；Y为主叫电话号码；Z为在线客服用户ID。
    * @param param 扩展参数
    */
    onRinging: function (calling, callee, callid, calldata, correlatedata, param) {
      let that = this
      console.log("呼叫振铃:", JSON.stringify([calling, callee, callid, calldata, correlatedata, param]))
      this.$emit('changeRecordStatus', 'ringing')
      // this.currentStatus = state
      this.telTime = ''
      this.recordInfo = {}

      this.recordInfo.caller = calling //记录主叫号码
      this.recordInfo.callee = callee //记录被叫号码  

      // 判断当前如果是呼入振铃态，则显示用户号码。
      this.currentStatus = ZteAgent.getState()
      console.log('currentStatus', this.currentStatus)


      this.currentCallType = ''
      // 座席号码
      let serviceNumber = ''
      // 咨询人号码
      let consultantNumber = ''
      let needUpload = false
      let pushData = {
        serviceCode: that.options.serviceCode,
        appId: that.options.appId,
        startTime: that.$moment().format('YYYY-MM-DD HH:mm:ss'),
        caller: that.recordInfo.caller,
        callee: that.recordInfo.callee,
        agentIds: [that.loginInfo.operatorId],
        serviceAccounts: [that.$store.getters['userInfo/account']],
      }
      switch (this.currentStatus.toString()) {
        case '312':
          //"312"  :  "呼入振铃" , 
          this.currentCallType = 'INBOUND'
          this.recordInfo.callType = 'INBOUND'
          this.callingNumber = calling
          consultantNumber = calling
          serviceNumber = callee
          needUpload = true

          this.$emit('onCallComing', {
            caller: calling,
            jobId: callid
          })
          break
        case '313':
          // "313"  :  "呼出振铃" , 
          needUpload = true
          this.currentCallType = 'OUTBOUND'
          this.recordInfo.callType = 'OUTBOUND'
          serviceNumber = calling
          try {
            consultantNumber = that.getRealNumber(callee)

          } catch (error) {
            console.log('getRealNumber error', error)
            consultantNumber = callee
          }

          this.calleeNumber = consultantNumber
          pushData.callee = consultantNumber
          this.recordInfo.callee = consultantNumber

          break
      }

      pushData.callType = that.recordInfo.callType
      ZteAgent.getConnectionId((id) => {
        console.log("getConnectionId", id)
        that.currentSerialNum = id
        pushData.serialNum = id
        if (needUpload) {
          that.$emit('pushCallRecord', pushData)
        }
      })

      this.nearlyCall(this.currentCallType, consultantNumber)

      //更新随路数据
      ZteAgent.getSvcData(function (ret, data) {
        that.calldata = data
        console.log('getSvcData', data)
        // $('#calldata').val(data)
      })
    },
    /**
   * 通话建立事件
   * callid	呼叫ID
   * calling	主叫号码
   * called	被叫号码
   * extendParam	保留的扩展参数，JSON类型。
   */
    onTalking: function (callid, calling, called, extendParam) {
      console.log("通话建立:" + JSON.stringify([callid, calling, called, extendParam]))
      this.$emit('changeRecordStatus', 'establish')
      this.$emit('updateCallRecord', this.options.appId, this.currentSerialNum, 'establish')
      this.addMessages("通话建立")
      //计时器
      this.callTimer()
    },

    /**
     * 挂机事件
     * 事件说明： 呼叫正常结束或者发起呼叫失败事件。
     * 触发条件： 呼叫正常结束或者发起呼叫失败时触发，所有的座席都收到此事件。
     * @param droper	发起呼叫结束的电话，如果被强拆，则该号码是发起强拆的电话，如果被系统挂机，则该号码固定为“00000000”。
     * @param dropee	被结束的电话
     * @param callid	本次呼叫ID
     * @param cause	发起呼叫失败原因：
     * 				3 被叫忙 
     * 				5 呼叫取消 
     * 				8 无应答 
     * 				13 用户不可达 fsig
     * 				15 用户不存在 
     * 				61 媒体不匹配 
     * 				30 服务不可用 
     * 				56 超时
     * 				70 未知原因
     * @param lcstate	该callid对应的座席自身的状态。0-表明该座席已从指定的callid的呼叫中退出
     * @param reason	sip呼叫失败码
     * @param paramObj	扩展参数，JSON类型
     */
    onRelease: function (droper, dropee, callid, cause, lcstate, reason, extendParam) {
      let that = this
      console.log("挂机成功，参数：" + JSON.stringify([droper, dropee, callid, cause, lcstate, reason, extendParam]))
      this.addMessages("挂机成功，参数：" + JSON.stringify([droper, dropee, callid, cause, lcstate, reason, extendParam]))
      this.$emit('onCallRelease', { appId: this.options.appId, serialNum: this.currentSerialNum, droper, dropee, callid, cause, lcstate, reason, extendParam })
      var _callendtime = new Date()
      this.recordInfo.callendtime = this.$moment().format("YYYY-MM-DD HH:mm:ss") // 记录通话结束时间
      // that.$emit('updateCallRecord', that.options.appId, this.currentSerialNum, 'release')
      // that.$emit('changeRecordStatus', 'release')
      this.clearCallTimer()

      // ZteAgent.getAgentPhoneNO(function (data) {
      //   that.recordInfo.agentphone = data // 记录座席分机号码
      //   that.recordInfo.vcid = that.options.params.centerCode //parseInt($("#vcid").val(), 10) //记录vcid	  
      //   // that.recordInfo.usrinfo = $("#usrinfo").val() == "" ? "userinfo" : $("#usrinfo").val() //记录客户号
      //   var date1 = that.soundRecording.recordstarttimeDate
      //   that.recordInfo.durtime = Math.round((_callendtime.getTime() - date1.getTime()) / 1000) // 记录录音时长（单位：秒);
      //   that.recordInfo.agentid = that.loginInfo.operatorId //$("#operatorId").val() //记录座席工号
      //   // 此功能暂时屏蔽  
      //   that.addRecordInfo() // 调用MR记录录音相关信息	  
      // })
    },
    pageChange: function (page) {
      console.log('pageChange', page)
      let _this = this
      this.loadingHis = true
      this.historyRecords = []
      let pageParams = {
        pageable: true,
        pageNo: page,
        pageSize: 10,
      }

      let params = new this.$URLSearchParams()
      params.append("pageParams", JSON.stringify(pageParams))
      this.$axios.post(_this.$apis.HLConfigApi.callRecord.nearlyCallPage, params, { baseURL: this.baseURL }).then(res => {
        _this.loadingHis = false
        if (res.success) {
          _this.historyRecordTotal = res.result?.total || 0
          _this.historyRecords = res.result?.data || []
          _this.historyRecords.forEach(element => {
            if (element.whenUpdated) element.whenUpdated = _this.$common.getDate(element.whenUpdated)
            if (element.whenCreated) element.whenCreated = _this.$common.getDate(element.whenCreated)
          })
        } else {
          _this.$Message.error({
            content: res.message,
            duration: 3
          })
        }
      }).catch(function (err) {
        _this.loadingHis = false
        _this.$Message.error({
          content: '数据获取失败！',
          duration: 3
        })
      })
    },
    addNumber: function (num) {
      this.calleeNumber += num
    },
    changeStatus: function (name) {
      if (this.operatorStatus != name) {
        this.operatorStatus = name
        switch (name) {
          case 'online':
            this.logIn()
            break
          case 'offline':
            this.logOut()
            break
          case 'idle':
            this.clickSetIdle()
            break
          case 'busy':
            this.clickSetBusy()
            break
        }
      }

    },
    adjust: function () {
      let that = this
      try {
        if (that.handlerTimer) {
          clearInterval(that.handlerTimer)
          that.handlerTimer = null
        }
        this.handlerSec = 60
        ZteAgent.adjust(60, function (isSucc, errCode) {
          console.log(isSucc, errCode)
          if (isSucc) {
            that.addMessages('进入事后处理')
          }
        })
        that.$emit('changeRecordStatus', 'handle')
        that.handlerTimer = setInterval(() => {
          that.handlerSec--
          console.log('事后处理还剩', that.handlerSec)
          if (that.handlerSec == 0) {
            that.cancelAdjust()
          }
        }, 1000)
      } catch (err) {
        console.log('adjust error', err)
      }
    },
    cancelAdjust: function () {
      let that = this
      if (this.currentStatus == 400 || this.currentStatus == 401) {
        ZteAgent.cancelAdjust()
        that.$emit('changeRecordStatus', 'idle')
        if (that.handlerTimer) {
          clearInterval(that.handlerTimer)
          that.handlerTimer = null
        }
        // todo 清除所有的状态 
      }
    },
    callP: function (data) {
      switch (data.callType) {
        case 'OUTBOUND':
          this.calleeNumber = data.callee
          this.clickMakeCall()
          break
        case 'INBOUND':
          this.calleeNumber = data.caller
          this.clickMakeCall()
          break
      }
    },
    loadCallRecord: function (data) {
      this.$emit('loadCallRecord', this.options.appId, data.serialNum)
    },
    logIn: function () {
      console.log('start logIn')
      this.clickBtnSignIn()
    },
    logOut: function () {
      console.log('start logOut')
      this.clickSignOut()
    },
    currentUserIno: function () {
      let that = this
      that.$axios.post(that.$apis.HLConfigApi.hlAccountApi.currentUserIno, null, {
        baseURL: this.baseURL
      }).then(res => {
        if (res.success) {
          that.currentUser = res.result || {}
          that.loginInfo.operatorId = that.currentUser.userId
          that.loginInfo.password = that.currentUser.pwd
          that.loginInfo.phoneType = that.currentUser.phoneType || '0'
          that.loginInfo.mobile = that.currentUser.mobile
          that.loginInfo.extension = that.currentUser.extension

          that.$nextTick(() => {
            that.initDom(that.hlLawyerStatus)
          })
        } else {
          that.$Message.error({
            content: res.message || '获取当前座席信息失败！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('that error', err)
        that.$Message.error({
          content: '获取当前座席信息失败',
          duration: 3
        })
      })
    },
    handlePanel: function (show) {
      console.log('zte handlePanel', show)
    },

    /** 获取目标号码类型，不一定使用正则表达式逻辑
    * 目的是能够自动判断一个号码的类型：工号、外部号码、sip号码、ip话机分机号码、ivr接入码、技能号。
    * @param callee 目标号码
    */
    getTargetNoType: function (callee) {
      if (new RegExp(this.targetNoType.agtId).test(callee)) {
        return "agtId"
      }
      else if (new RegExp(this.targetNoType.ivrCode).test(callee)) {
        return "ivrCode"
      }
      else if (new RegExp(this.targetNoType.usrPhone).test(callee) || new RegExp(this.targetNoType.usrTel).test(callee)) {
        return "outerPhone"
      }
      else if (new RegExp(this.targetNoType.skill).test(callee)) {
        return "skill"
      }
      else if (new RegExp(this.targetNoType.sipPhone).test(callee)) {
        return "sipPhone"
      }
      return 'unknow'
    },
    clearCallTimer: function () {
      this.calleeNumber = ''
      if (this.timerid) {
        this.timerBegin = 0
        clearInterval(this.timerid)
        this.timerid = null
      }
    },
    // 计时器方法
    callTimer: function () {
      this.clearCallTimer()
      let that = this
      if (ZteAgent.isCalling()) {
        this.timerBegin = new Date().getTime()
        this.timerid = setInterval(function () {
          console.log('calc isCalling ', that.timerBegin)
          var callTime = new Date().getTime() - that.timerBegin
          console.log('calc callTime ', callTime)
          var hours = Math.floor(callTime / 1000 / 3600)
          if (hours < 10) {
            hours = "0" + hours
          }

          var minutes = Math.floor(callTime / 1000 / 60 % 60)
          if (minutes < 10) {
            minutes = "0" + minutes
          }

          var seconds = Math.floor(callTime / 1000 % 60)
          if (seconds < 10) {
            seconds = "0" + seconds
          }

          that.telTime = hours + ":" + minutes + ":" + seconds
          console.log('calc time ', that.telTime)
        }, 1000)
      }

    },

    /**
     * 状态改变事件
     * 
     * @param state 当前状态
     * @param lastState  上一状态
     * @param cause 改变原因
     * @param param  扩展参数
     */
    onCTIAgentStateChanged: function (state, lState, cause, param) {
      this.lastStatus = lState
      // 显示当前状态
      this.currentStatus = state
      this.addMessages("座席由状态【" + (this.stateMap[lState] || lState) + "】切换至[" + (this.stateMap[state] || state) + "]")
      if (this.currentStatus != this.lastState && (this.currentStatus == 400 || this.currentStatus == 401)) {
        this.clearCallTimer()
        this.adjust()
        if (lState == 312 || lState == 313 || lState == 314 || lState == 315 || lState == 316 || lState == 300 || lState == 302) {
          // 关闭咨询件
          let type = ''
          if (lState == 300) {
            // inbound("呼入通话，通话中挂断")
            type = 'inbound'
            this.$emit('updateCallRecord', this.options.appId, this.currentSerialNum, 'release')
          } else if (lState == 302) {
            // outbound("呼出通话，通话中挂断")
            type = 'outbound'
            this.$emit('updateCallRecord', this.options.appId, this.currentSerialNum, 'release')
          } else if (lState == 313 || lState == 316) {
            // dialing("呼出未接时挂机"),
            type = 'dialing'
            this.$emit('hangUpRecord', type)
          } else {
            // ringing("呼入未接时挂机"),
            type = 'ringing'
            this.$emit('hangUpRecord', type)
          }

        }
      } else if (this.currentStatus == 1 || this.currentStatus == 2 || this.currentStatus == 3 || this.currentStatus == 4 || this.currentStatus == 102 || this.currentStatus == 103 || this.currentStatus == 104) {
        // this.$emit('changeStatus', false)
        this.clearCallTimer()
        if (this.handlerTimer) {
          clearInterval(this.handlerTimer)
          this.handlerTimer = null
        }
      }
    },

    /**
     * 座席状态改变事件
     */
    onStateChanged: function (state) {
      switch (state.toString()) {
        case "0": case "1": case "2": case "3": case "4":
          this.operatorStatus = 'offline'
          this.viewModel = 'numberPanel'
          break
        case "105": case "106":
          // 示忙
          this.operatorStatus = 'busy'
          this.viewModel = 'numberPanel'
          this.panelMode == 'normal'
          break
        case "200": case "201": case "202": case "203":
          this.viewModel = 'numberPanel'
          this.operatorStatus = 'idle'
          break
        case "107": case "312": case "313": case "314": case "315":
          //准备呼入 & 响铃中
          this.viewModel = 'telRingPanel'
          this.operatorStatus = 'idle'
          this.panelMode == 'normal'
          break
        case "300": case "301": case "302": case "303": case "304": case "305": case "306": case "307": case "308": case "309": case "310":
          this.viewModel = 'telRingPanel'
          this.operatorStatus = 'idle'
          this.panelMode == 'normal'
          break
      }
    },


    getRealNumber: function (orgNumber) {
      let tarketType = this.getTargetNoType(orgNumber)
      console.log('getRealNumber ' + tarketType, orgNumber)
      switch (tarketType) {
        case 'agtId':
        //座席工号
        case 'skill':
        // 技能号
        case 'ivrCode':
          // IVR号码
          return orgNumber
        default:
          // 外部号码
          if (orgNumber.indexOf(this.phonePre) == 0) {
            return orgNumber.slice(3)
          }
          break
      }
      return orgNumber
    },
    /**
     * 获取最近的通话信息
     */
    nearlyCall: function (callType, telNumber) {
      let that = this
      let params = new this.$URLSearchParams()
      params.append("callType", callType)
      params.append("telNumber", telNumber)
      this.$axios.post(that.$apis.HLConfigApi.callRecord.nearlyCall, params, {
        baseURL: this.baseURL
      }).then(res => {
        if (res.success) {
          console.log('nearlyCall success')
          that.nearlyCallInfo = res.result || {}
        } else {
          console.log('nearlyCall fail', res)
        }
      }).catch(function (err) {
        console.log('nearlyCall err', err)
      })
    },
    /**
     * 接听电话
    * 到振铃事件后调用应答接口接听
     */
    answerTel: function () {
      ZteAgent.answer(function (isSucc, errCode) {
        if (!isSucc) {
          this.addMessages("接听失败，错误码(" + errorCode + ")，请联系系统管理员！")
        }
      })
    },

    /**
     * 呼叫失败原因事件
     * @param cause
     * @param param
     */
    onFailCause18X: function (cause, param) {
      this.addMessages("呼叫失败原因事件:" + JSON.stringify([cause, param]), "error")
    },

    /**
     * CTI通知事件
     */
    onCtiReport: function (eventtype, param) {
      console.log('onCtiReport', eventtype)
      console.log('onCtiReport param', param)
      switch (eventtype) {
        case 1:
          //被CTI强制签出
          // param case=1: sipphone断链
          // param cause=2: 虚拟中心被停用
          // param cause=3: 座席在其他地方登录
          // param cause=4: NGCCMAN上强制签出
          break
      }
      this.addMessages("通知事件:" + JSON.stringify([eventtype, param]), "error")
    },

    /**
     * 录音事件
     * @param type 0：录音开始 1：录音结束
     * @param errcode 0：成功，非0：失败码
     * @param filename 格式：dvcid=xxx;initpath=xx;recordpath=xxx;
     * 			dvcid是虚拟中心；
     * 		 	initpath为录音文件初始化路径；
     * 			recordpath为录音文件相对路径（包含文件名）；
     * @param reckey 录音唯一标识符，对应录音表中的keystr字段
     */
    onRecord: function (type, errcode, filename, reckey) {
      console.log('onRecord', { type, errcode, filename, reckey })
      this.soundRecording = JSON.stringify([type, errcode, filename, reckey])
      if (type == "1") {
        if (errcode == "0") {
          this.$emit('updateSoundRecording', { type: type, appId: this.options.appId, serialNum: this.currentSerialNum, filePath: filename, reckey: reckey })
        } else {
          this.$Message.error({
            content: '录音文件提交失败！',
            duration: 0,
            closable: true
          })
        }
      } else if (type == '0') {
        this.$emit('updateSoundRecording', { type: type, appId: this.options.appId, serialNum: this.currentSerialNum, filePath: filename, reckey: reckey })
      }
      // this.addMessages("录音事件:" + this.recordInfo)
    },

    /**
     * 录音技术事件
     * @param fileName 文件名，格式为：dvcId=100;initPath=rec207204;recPath=xxxxxxx/yy.wav
     * @param fileLength
     */
    onRecordEvent: function (fileName, fileLength) {
      let that = this
      console.log('开始结束', fileName)
      // this.addMessages("录音开始事件:" + JSON.stringify([fileName, fileLength]))
      var _recordstarttime = new Date()
      this.soundRecording.recordstarttime = this.$moment().format("YYYY-MM-DD HH:mm:ss") // 记录录音开始时间
      this.soundRecording.recordstarttimeDate = _recordstarttime
      var exts = fileName.split(";")
      this.soundRecording.nfsinitpath = exts[1].split("=")[1] // 记录initpath
      this.soundRecording.recordpath = exts[2].split("=")[1]  // 记录recordpath

      ZteAgent.getRecordRelatedInfo(function (data) {
        console.log("录音相关信息:", data)
        //录音记录标识|呼叫流水号|呼叫ID 
        that.soundRecording.keystr = data.split("|")[0]  //记录keystr
        that.soundRecording.connectionid = data.split("|")[1]  //记录connectionid
        that.addRecordInfo()
      })

    },

    /**
     * 报工号结束事件
     */
    onPlayEnd: function () {
      this.addMessages("报工号结束事件")
    },


    /**
    * 挂机事件
    * 事件说明： 咨询方挂机事件
    * 触发条件： 座席发起咨询且与被咨询方建立通话、座席主动结束与被咨询方的通话、被咨询方主动挂机、reconnect操作都会触发该事件。
    * @param calling
    * @param called
    * @param callid
    * @param extendParam
    */
    onConsultBack: function (calling, called, callid, extendParam) {
      console.log("咨询方挂机事件，参数：" + JSON.stringify([calling, called, callid, extendParam]))
      this.addMessages("咨询方挂机事件，参数：" + JSON.stringify([calling, called, callid, extendParam]))
    },

    // 调用MR接口，记录录音相关信息
    addRecordInfo: function () {
      // 如果挂机类型为空，则认为是用户挂机
      if (!this.recordInfo.callendtype) {
        this.recordInfo.callendtype = 1
      }

      // 如果呼叫类型为空，则认为是用户呼入
      if (!this.recordInfo.calltype) {
        this.recordInfo.calltype = 1
      }

      // 删除录音记录开始时间对象属性
      delete this.recordInfo["recordstarttimeDate"]

      // 调用MR记录录音相关信息
      var id = "spdb.insertRec"
      $.mr().handleData(id, this.soundRecording).onSucc((res) => {
        console.log('addRecordInfo success', res)
        alert()
        this.addMessages("录音记录保存成功！")
      }).onErr((res) => {
        this.addMessages("录音记录保存失败！" + JSON.stringify(res))
      })
      // 清除本次this.recordInfo 对象。
      this.soundRecording = {}
    },

    /**
     * 咨询转事件
     */
    onTransfered: function (transtel, calling, called, callid, calldata, extendParam) {
      this.addMessages("咨询转接成功，参数：" + JSON.stringify([transtel, calling, called, callid, calldata, extendParam]))
    },

    /**
     * 单步转事件
     */
    onSingleTransfered: function (transtel, calling, called, callid, extendParam) {
      this.addMessages("单步转接成功，参数：" + JSON.stringify([transtel, calling, called, callid, extendParam]))
    },

    /**
     * 加入会议成功事件
     * @param d1
     * @param d2
     * @param d3
     * @param callid
     * @param cause
     * @param calldata
     * @param extendParam
     */
    onConference: function (d1, d2, d3, callid, cause, calldata, extendParam) {
      this.addMessages("加入会议成功事件，参数：" + JSON.stringify([d1, d2, d3, callid, cause, calldata, extendParam]))
    },

    /**
     * 会议成员变化事件
     * @param callid
     * @param devicelist
     * @param extendParam
     */
    onSnapShotCall: function (callid, devicelist, extendParam) {
      this.addMessages("会议成员变化事件，参数：" + JSON.stringify([callid, devicelist, extendParam]))
    },

    /**
     * 远端咨询返回事件
     * @param ivrdata
     * @param extendParam
     */
    onReturnFromIVR: function (ivrdata, extendParam) {
      this.addMessages("远端咨询返回事件，参数：" + JSON.stringify([ivrdata, extendParam]))
    },


    /**
     * 
     */
    onShareStart: function (result, content, remoteType, vcId, remoteId, exInfo) {
      this.addMessages("onShareStart，参数：" + JSON.stringify([result, content, remoteType, vcId, remoteId, exInfo]))
      if (result * 1 == 0) {
        this.btnStartRemoteShareToAgent.attr("disabled", "disabled")
        this.btnStopRemoteShareToAgent.removeAttr("disabled")
        this.btnChangeRemoteShareToAgent.removeAttr("disabled")
      } else {
        this.btnStartRemoteShareToAgent.removeAttr("disabled")
        this.btnStopRemoteShareToAgent.attr("disabled", "disabled")
        this.btnChangeRemoteShareToAgent.attr("disabled", "disabled")
      }
    },

    /**
     * 
     */
    onShareStop: function (remoteType, vcId, remoteId, exInfo) {
      this.addMessages("onShareStop，参数：" + JSON.stringify([remoteType, vcId, remoteId, exInfo]))

      this.btnStartRemoteShareToAgent.removeAttr("disabled")
      this.btnStopRemoteShareToAgent.attr("disabled", "disabled")
      this.btnChangeRemoteShareToAgent.attr("disabled", "disabled")
    },

    onShareTypeChange: function (result, shareType, remoteType, vcId, remoteId, exInfo) {
      this.addMessages("onShareTypeChange，参数：" + JSON.stringify([result, shareType, remoteType, vcId, remoteId, exInfo]))
    },
    //  被强制示忙
    onForceBusy: function (srcAgt) {
      this.addMessages("您已经被班长(" + srcAgt + ")强制示忙")
    },

    //  被强制示闲
    onForceIdle: function (srcAgt) {
      this.addMessages("您已经被班长(" + srcAgt + ")强制示闲")
    },

    //  被强制签出
    onForceOut: function (srcAgt) {
      this.addMessages("您已经被座席：" + srcAgt + " 强制签出")
    },

    //  呼叫被拦截
    onBeIntercepted: function () {
      this.addMessages("您与用户的本次通话已被其他座席拦截")
    },

    /**
     * 提示最后一次发生的错误
     */
    promptLastError: function () {
      let that = this
      ZteAgent.getLastErrorCode(function (errorCode) {
        that.addMessages("errorCode:[" + errorCode + "]", 'error')
      })
    },

    /**
     * 获取操作参数
     * @returns
     */
    getParam: function () {
      if (this.calleeNumber.length == 0) {
        this.addMessages("未输对方号码", 'error')
        return null
      }
      return this.calleeNumber
    },
    checkHeart: function () {
      this.$axios.post(this.$apis.HLConfigApi.hlAccountApi.checkHeart, null, {
        baseURL: this.baseURL
      }).then(res => {
        console.log('checkHeart', res)
      }).catch(function (err) {
        console.log('checkHeart error', err)

      })
    },
    /**
     * 执行登录
     */
    doSignIn: function () {
      let that = this
      // let phoneNo = this.loginInfo.extension // 67885678 座席分机号码
      let phoneNo = this.loginInfo.mobile // 67885678 座席分机号码
      //PC+PHONE方式需要绑定分机号码
      if (this.loginInfo.phoneType == '2' && phoneNo == "") {
        this.addMessages("未配置座席号码！", 'error')
        return
      }
      this.$emit('changePanel', true)
      this.loginLoading = true
      // try {
      //   ZteAgent.signOut()
      // } catch (error) {
      //   console.log('signOut error in signin', error)
      // }
      var signInParams = {
        type: "sipphone", //座席解决方案类型，填写固定值sipphone
        cfgUrl: this.options.params.baseUrl, //零配置url地址
        vcid: this.options.params.centerCode, // 虚拟中心编号
        agtId: this.loginInfo.operatorId, //工号
        pwd: this.$MD5.hex_md5(this.loginInfo.password).toUpperCase(), //密码（MD5算法加密后的密文）
        extendParam: {
          autoAnswer: false, //来电后是否自动应答
          initialReady: true, // 签入成功后是否自动示闲  若设置成功，CTI有来话时可以给座席分配处理
          useVideo: ("2" == this.loginInfo.mediaType ? true : false),  //是否使用视频				
          fullRecord: true, //是否全程录音/录像
          recordMode: 1, //录音/录像模式：0-本地录（默认），1-媒体服务器录，2-本地录，且外呼时振铃就开始录音，无特殊需求不建议使用该模式。 
          isShowLocalVideoWindow: true, //如果是视频模式，则由AgentService弹出视频窗口	s		
          /**s
           * 报工号方式：
          * 0-座席应答呼叫后播放工号。
          * 1-用户呼入/用户转接到话务员之后播放工号，座席之间通话不播放工号。
          * 2-只在用户被转接到座席后播放工号。
           */
          repworknum: 0,
        },
        phoneType: this.loginInfo.phoneType,
        bindPhone: phoneNo
      }

      // 防止重复点击	
      this.lastStatus = 0
      this.currentStatus = 100
      // this.btnSignIn.attr("disabled", "disabled")
      // this.addMessages("正在登陆，请稍候......")
      try {
        // 异步回调函数, function(isSucc, errCode) isSucc为true表示成功，false为失败，此时errCode为错误码。
        ZteAgent.signIn(signInParams, function (isSucc, errorCode) {
          let msg = ''
          if (!isSucc) {
            that.operatorStatus = 'offline'
            that.currentStatus = 0
            msg = "签入失败，错误码(" + errorCode + ")，请联系系统管理员！"
            that.addMessages(msg, 'error')
            that.$emit('changeStatus', false)

          } else {
            msg = "签入成功！"
            that.operatorStatus = 'idle'
            that.$emit('changeStatus', true)
            that.currentStatus = ZteAgent.getState()
            that.checkHeartTimer = setInterval(() => {
              that.checkHeart()
            }, 60000)
          }
          that.$emit('signLog', { appId: that.options?.appId, seatId: that.loginInfo?.operatorId, logType: 'signIn', logStatus: isSucc, remark: msg })
          that.loginLoading = false
        })
      } catch (err) {
        console.log('signIn error', err)
        let msg = "签入失败，请联系系统管理员！"
        that.operatorStatus = 'offline'
        that.$emit('signLog', { appId: that.options?.appId, seatId: that.loginInfo?.operatorId, logType: 'signIn', logStatus: false, remark: msg })
        that.addMessages(msg, 'error')
        that.$emit('changeStatus', false)
        that.currentStatus = 0
        that.loginLoading = false
      }
    },

    /**
     * 点击登录按钮事件
     */
    clickBtnSignIn: function () {
      if (this.options.params.baseUrl?.length == 0) {
        this.$Message.warning("未输入零配置服务器地址")
        this.addMessages("未输入零配置服务器地址", 'error')
        return
      }

      let vcid = this.options.params.centerCode || ''
      if (vcid.length == 0) {
        this.$Message.warning("未输入VCID")
        this.addMessages("未输入VCID", 'error')
        return
      }

      vcid = parseInt(vcid, 10)
      if (isNaN(vcid)) {
        this.addMessages("VCID应为整数", 'error')
        return
      }

      let operatorId = this.loginInfo.operatorId || ''
      if (operatorId.length == 0) {
        this.$Message.warning("未知座席账号密码")
        this.addMessages("未知座席工号", 'error')
        return
      }

      operatorId = parseInt(operatorId, 10)
      if (isNaN(operatorId)) {
        this.addMessages("工号应为整数", 'error')
        return
      }

      let password = this.loginInfo.password || ''
      if (password.length == 0) {
        this.$Message.warning("未知座席账号密码")
        this.addMessages("未输入密码", 'error')
        return
      }
      this.doSignIn()
    },

    /**
     * 点击示闲按钮
     */
    clickSetIdle: function () {
      let that = this
      ZteAgent.idle(function (isSucc, errCode) {
        let msg = ""
        if (!isSucc) {
          msg = "示闲失败，错误码(" + errCode + ")，请联系系统管理员！"
          that.addMessages(msg, "error")
        }
        else {
          msg = "示闲成功！"
        }
        that.$emit('signLog', { appId: that.options.appId, seatId: that.loginInfo.operatorId, logType: 'setIdle', logStatus: isSucc, remark: msg })
      })
    },

    /**
     * 点击示忙按钮
     */
    clickSetBusy: function () {
      let that = this
      ZteAgent.busy(function (isSucc, errCode) {
        let msg = ""
        if (!isSucc) {
          msg = "示忙失败，错误码(" + errCode + ")，请联系系统管理员！"
          that.addMessages(msg, "error")
        } else {
          msg = "示忙成功！"
        }
        that.$emit('signLog', { appId: that.options.appId, seatId: that.loginInfo.operatorId, logType: 'setBusy', logStatus: isSucc, remark: msg })
      })
    },

    /**
     * 点击呼出座席按钮
     */
    clickMakeCall: function () {
      let that = this
      if (this.calleeNumber == null || this.calleeNumber.length == 0) {
        that.$Message.warning("请输入呼出号码!")
        return
      }
      let objType = 0  //目标类型0-座席；1-网络用户；2-用户
      // 伪主叫号码，如果为空，请填空字符串“”。
      let callingNo = this.options.params.callingNo ? this.options.params.callingNo : ''
      let userData = '', extendParams = null
      this.recordInfo.calltype = 6    //座席主动呼出用户
      this.recordInfo.callType = 'OUTBOUND'   //座席主动呼出用户
      let tarketType = this.getTargetNoType(this.calleeNumber)
      let callTel = this.calleeNumber
      switch (tarketType) {
        case 'agtId':
          //座席工号
          objType = 0
          this.recordInfo.calltype = 7   //座席呼座席
          this.recordInfo.callType = 'INTERNAL'
          break
        case 'sipPhone':
          // sip用户
          objType = 1
          break
        default:
          // 外部号码
          objType = 2
          let reg2 = /^0\d{2,3}-?\d{5,10}$/
          if (!reg2.test(this.calleeNumber)) {
            callTel = this.phonePre + this.calleeNumber
          }
          break
      }

      try {
        //呼叫类型： 1-音频;2-视频
        ZteAgent.makeCall(this.loginInfo.mediaType, objType, callTel, callingNo, userData, extendParams, function (isSucc, errCode) {
          if (!isSucc) {
            that.addMessages("拨打电话失败，错误码(" + errCode + ")，请联系系统管理员！", "error")
            that.clickSetIdle()
            return
          } else {
            // 正在拨打电话
            that.$emit('changeRecordStatus', 'calling')
          }
        })
      } catch (err) {
        console.log('makeCall err', err)
        that.addMessages("拨打电话" + that.calleeNumber + "失败！", 'error')
      }
    },

    /**
     * 点击显示
     */
    showHistory: function () {
      this.viewModel = 'history'
      this.pageChange(1)
    },
    showOPHis: function () {
      this.viewModel = 'opHis'
    },
    backPanel: function () {
      this.viewModel = 'numberPanel'
    },

    /**
    *点击挂机按钮
    */
    clickHangup: function () {
      let that = this
      this.recordInfo.callendtype = 2 // 座席主动挂机
      this.$emit('changeRecordStatus', 'hangUp')
      this.clearCallTimer()
      if (this.currentStatus == 305) {
        // 会议话机
        this.popUp("conf.html", 300, 150, "confWin")
      } else {
        var userData = ""
        let type = ''

        // if (this.currentStatus == 312) {
        //   // ringing("呼入未接时挂机"),
        //   type = 'ringing'
        // } else if (this.currentStatus == 313) {
        //   // dialing("呼出未接时挂机"),
        //   type = 'dialing'
        // } else if (this.currentStatus == 300) {
        //   // inbound("呼入通话，通话中挂断")
        //   type = 'inbound'
        // } else if (this.currentStatus == 302) {
        //   // outbound("呼出通话，通话中挂断")
        //   type = 'outbound'
        // }

        ZteAgent.hangUp(userData, function (isSucc, errCode) {
          if (!isSucc) {
            that.promptLastError()
          } else {
            // if (type) {
            //   that.$emit('hangUpRecord', type)
            // }
          }
        })
      }

    },

    /**
    *挂机挂自己
    */
    clickHangupMyself: function () {
      // 座席号码
      let that = this
      var agentPhone = ZteAgent.getAgtInfo().phoneNo
      ZteAgent.releaseCall(agentPhone, "", null, function (isSucc, errCode) {
        if (!isSucc) {
          that.addMessages("挂自己失败,错误码:" + errCode, 'error', 'error')
        } else {
          that.addMessages("挂自己成功！")
        }
      })

    },

    /**
    * 获取当前的通话号码 
    */
    getAllPhoneNo: function (fn) {
      ZteAgent.getAllPartsPhoneNo(fn)
    },

    /**
    * 打开窗口
    */
    popUp: function (url, width, height, winname, left, top) {
      if (width == '' || width == null) {
        width = screen.width
      }
      if (height == '' || height == null) {
        height = screen.height
      }
      var _top = (top == '' || top == null) ? (screen.height - height) / 2 : top
      var _left = (left == '' || left == null) ? (screen.width - width) / 2 : left
      var _winname = (winname == undefined || winname == null || winname == '') ? '_blank' : winname
      window.open(url, _winname,
        'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,copyhistory=yes,width='
        + width + ',height=' + height + ',left=' + _left + ', top=' + _top + ',screenX=' + left + ',screenY=' + top + '')

    },

    /**
    *会议中挂断某个成员号码
    */
    hangupPhone: function (phone, fn) {
      ZteAgent.releaseCall(phone, "", "", fn)
    },


    /**
     * 点击保持按钮
     */
    clickHold: function () {
      let that = this
      ZteAgent.hold(function (isSucc, errCode) {
        if (!isSucc) {
          that.promptLastError()
        }
      })
    },

    /**
     * 点击取消保持按钮
     */
    clickCancelHold: function () {
      let that = this
      ZteAgent.cancelHold(function (isSucc, errCode) {
        if (!isSucc) {
          this.promptLastError()
        }
      })
    },

    /**
     * 点击转接(咨询状态下可用)按钮
     */
    clickTransfer: function () {
      let that = this
      ZteAgent.consultTransfer(function (isSucc, errCode) {
        if (!isSucc) {
          that.promptLastError()
        }
      })
    },

    /**
     * 点击单步转接按钮
     */
    clickSingleStepTransfer: function () {
      let that = this
      // 转接类型 0:座席工号，1：外部号码，2：技能组标识，3：IVR业务
      let transferType = 1
      let dstObj, callingNo = "", userData = "", paramObj = null
      dstObj = this.getParam()
      if (dstObj == null) {
        alert("请输入转接的用户号码或者座席工号")
        return
      }

      let tarketType = this.getTargetNoType(dstObj)
      switch (tarketType) {
        case 'agtId':
          //座席工号
          transferType = 0
          break
        case 'skill':
          // 技能号
          transferType = 2
          break
        case 'ivrCode':
          // IVR号码
          transferType = 3
          break
        default:
          // 外部号码
          transferType = 1
          break
      }

      ZteAgent.singleStepTransfer(transferType, dstObj, callingNo, userData, paramObj, function (isSucc, errCode) {
        if (!isSucc) {
          that.promptLastError()
        }
      })
    },

    /**
     * 挂机转回IVR
     */
    clickTransferIVR: function () {
      let that = this
      // 注意：如果回到原来IVR业务的某个节点上，则需要修改calldata内容。具体需要咨询IVR开发人员。
      //var calldata = "{\"NavigateMenu\":\"1000-1-1\"}";

      // 满意度收集流程，
      var calldata = "{\"appraise\":\"1\"}"

      ZteAgent.clearCallToAutoService(calldata, function (isSucc, errCode) {
        if (!isSucc) {
          that.promptLastError()
        }
      })
    },

    /**
     * 点击咨询到IVR验证按钮
     */
    clickConsultIVR: function () {
      let that = this
      // 咨询号码类别。0：座席工号，1：外部号码，2：技能组标识，3：远端咨询到IVR/MS,
      var consultType = 3, dstObj, callingNo = "", userData = "", paramObj = null
      dstObj = getParam()
      if (dstObj == null) {
        alert("请输入远端咨询IVR号码")
        return
      }
      ZteAgent.consult(consultType, dstObj, callingNo, userData, paramObj, function (isSucc, errCode) {
        if (!isSucc) {
          that.promptLastError()
        }
      })

    },

    /**
     * 点击设置随路数据按钮
     */
    clickSetCallData: function () {
      let that = this
      if (this.calldata == "") {
        var ret = window.confirm("您确认设置随路数据为空字符串吗？")
        if (!ret) {
          return
        }
      }

      ZteAgent.setSvcData(this.calldata, "", function (isSucc, errCode) {
        if (!isSucc) {
          that.promptLastError()
        } else {
          that.addMessages("设置随路数据成功!")
        }
      })
    },


    /**
     * 点击会议按钮（包含单步会议和咨询状态下的创建会议）
     */
    clickConference: function () {
      let that = this
      //获取当前座席状态码
      var status = parseInt(ZteAgent.getState(), 10)
      this.currentStatus = state
      // 咨询态下，直接调用会议方法
      if (status >= 306 && status <= 308) // 306,307,308咨询态
      {

        ZteAgent.conference(function (ret, errorCode) {
          if (ret) {
            //addMessages("会议操作成功!");
          }
          else {
            that.promptLastError()
          }
        })
      }
      else {
        // 其他状态（通话和会议）直接发起单步会议操作。	   
        // 被加入会议的目标号码/工号
        var callee = this.calleeNumber
        if (!callee) {
          this.addMessages("请输入需要加入会议的号码", 'error')
        }
        var objType = 1 //1:外部用户号码.0:座席工号	
        var tarketType = this.getTargetNoType(callee)
        if ("agtId" == tarketType) //座席工号
        {
          objType = 0
        }

        var callType = that.loginInfo.mediaType //呼叫类型： 1-音频;2-视频

        ZteAgent.singleStepConf(callType, callee, objType, 1, "", null, function (ret, errorCode) {
          if (ret) {
            //addMessages("加入会议成功!");
          }
          else {
            that.promptLastError()
          }
        })
      }
    },


    /**
     * 咨询态下取消与被咨询方通话并恢复被保持的通话
     */
    clickCancel: function () {
      let that = this
      ZteAgent.reconnect(function (isSucc, errCode) {
        if (!isSucc) {
          that.promptLastError()
        }
      })
    },

    /**
     *咨询
     */
    clickConsult: function () {
      let that = this
      // 咨询类型:0:座席工号，1：外部用户号码，2：技能，3：IVR
      var consultType = 1
      var dstObj = this.getParam()
      var callingNo = "", userData = "", paramObj = null
      if (dstObj == null) {
        return
      }
      var tarketType = this.getTargetNoType(dstObj)
      if ("agtId" == tarketType) //座席工号
      {
        consultType = 0
      }
      else if ("skill" == tarketType) // sip用户
      {
        consultType = 2
      }
      else if ("ivrCode" == tarketType) // IVR接入码
      {
        consultType = 3
      }
      else {
        consultType = 1 // 外部号码
      }

      ZteAgent.consult(consultType, dstObj, callingNo,
        userData, paramObj, function (isSucc, errCode) {
          if (!isSucc) {
            that.promptLastError()
          }
          else {
            that.addMessages("咨询操作成功!")
          }
        })
    },

    /**
     *切换
     */
    clickAlternate: function () {
      let that = this
      ZteAgent.alternate(function (isSucc, errCode) {
        if (!isSucc) {
          that.promptLastError()
        }
      })
    },

    /**
     *监听
     */
    clickListen: function () {
      let that = this
      ZteAgent.insert(this.calleeNumber, 0, 0, null, function (isSucc, errCode) {
        if (!isSucc) {
          that.promptLastError()
        }
        else {
          that.addMessages("监听操作成功！")
        }
      })
    },

    /**
     *强插
     */
    clickInsert: function () {
      let that = this
      ZteAgent.insert(this.calleeNumber, 0, 1, null, function (isSucc, errCode) {

        let msg = ""
        if (!isSucc) {
          msg = "强插失败，错误码(" + errorCode + ")，请联系系统管理员！"
          that.addMessages(msg, "error")
        } else {
          msg = "强插操作成功！"
          that.addMessages("强插操作成功！")
        }
        that.$emit('signLog', { appId: that.options.appId, seatId: that.loginInfo.operatorId, logType: 'insert', logStatus: isSucc, remark: msg })
      })
    },

    /**
     *强制示闲
     */
    clickForceIdle: function () {
      let that = this
      ZteAgent.forceIdle(this.calleeNumber, function (isSucc, errCode) {
        let msg = ""
        if (!isSucc) {
          msg = "强制示闲失败，错误码(" + errorCode + ")，请联系系统管理员！"
          that.addMessages(msg, "error")
        }
        else {
          msg = "强制示闲成功！"
          that.addMessages("强制示闲成功！")
        }
        that.$emit('signLog', { appId: that.options.appId, seatId: that.loginInfo.operatorId, logType: 'forceIdle', logStatus: isSucc, remark: msg })
      })
    },

    /**
     *强拆
     */
    clickForceClear: function () {
      let that = this
      ZteAgent.forceClear(this.calleeNumber, function (isSucc, errCode) {
        let msg = ""
        if (!isSucc) {
          msg = "强拆失败，错误码(" + errorCode + ")，请联系系统管理员！"
          that.addMessages(msg, "error")
        } else {
          msg = "强拆成功！"
          that.addMessages("强拆成功！")
        }
        that.$emit('signLog', { appId: that.options.appId, seatId: that.loginInfo.operatorId, logType: 'forceClear', logStatus: isSucc, remark: msg })
      })
    },

    /**
   * 点击签出按钮
   */
    clickSignOut: function () {
      let that = this
      try {
        ZteAgent.signOut(function (isSucc, errCode) {
          let msg = ""
          if (!isSucc) {
            msg = "签出失败，错误码[" + errCode + "], 请联系管理员！"
            that.addMessages(msg, 'error')
          } else {
            msg = "签出成功！"
            that.operatorStatus = 'offline'
            that.addMessages("签出成功！")
            that.$emit('changeRecordStatus', 'offline')
            that.$emit('changeStatus', false)
            if (that.checkHeartTimer) {
              clearInterval(that.checkHeartTimer)
              that.checkHeartTimer = null
            }
            // that.refreshBtns(0)
            // $("#state").val(0)
            // window.location.reload()
          }
          that.$emit('signLog', { appId: that.options.appId, seatId: that.loginInfo.operatorId, logType: 'signOut', logStatus: isSucc, remark: msg })
        })
      } catch (err) {
        console.log('clickSignOut error', err)
        that.$emit('signLog', { appId: that.options.appId, seatId: that.loginInfo.operatorId, logType: 'signOut', logStatus: false })
      }

    },

    /**
     *离线(强制签出)
     */
    clickForceOut: function () {
      let that = this
      ZteAgent.forceOut(this.calleeNumber, function (isSucc, errCode) {

        let msg = ""
        if (!isSucc) {
          msg = "强制离线失败，错误码(" + errorCode + ")，请联系系统管理员！"
          that.addMessages(msg, "error")
        }
        else {
          msg = "强制离线成功！"
          that.addMessages("强制离线成功！")
        }
        that.$emit('signLog', { appId: that.options.appId, seatId: that.loginInfo.operatorId, logType: 'forceOut', logStatus: isSucc, remark: msg })
      })
    },

    /**
     *调整技能  即，设置座席的临时技能。
     * agtId 目标座席工号
     * 重新设置的技能列表，采用字符串形式(最大字符串长度为1024个字节)。
     * 单个技能格式如下：”技能:技能优先级:接通比率”，其中，技能优先级范围：1-5 接通比率：0~100（单位：%）。多个技能之间用|分开,例如：如：”1:1:60|2:2:40|3:1:40”。
     */
    clickResetSkill: function () {
      let that = this
      // 座席号码
      var agtId = that.loginInfo.operatorId
      var skills = "5:1:100|6:2:40"
      ZteAgent.resetSkill(agtId, skills, null, function (isSucc, errCode) {
        let msg = ""
        if (!isSucc) {
          msg = "技能" + agtId + "调整失败，错误码(" + errCode + ")，请联系系统管理员！"
          that.addMessages(msg, "error")
        }
        else {
          that.addMessages("调整" + agtId + "的技能成功!")
        }
        that.$emit('signLog', { appId: that.options.appId, seatId: that.loginInfo.operatorId, logType: 'resetSkill', logStatus: isSucc, remark: msg })
      })
    },

    /**
     * 添加消息内容
     * @param msg 消息内容
     */
    addMessages: function (msg, status = 'success') {
      let that = this
      this.messageList.unshift({
        time: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        message: msg,
        status: status
      })
      // this.messageList.push({
      //   time: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
      //   message: msg,
      //   status: status
      // })
      // let params = {
      //   zteAccountId: this.currentUser.id,
      //   remark: msg,
      //   status: status
      // }
      // that.$axios.post(that.$apis.HLConfigApi.ZTEConfig.addLog, params, {
      //   baseURL: this.baseURL
      // }).then(res => {
      //   if (!res.success) {
      //     console.log('addMessages fail', res)
      //   }
      // }).catch(function (err) {
      //   console.log('addMessages error', err)
      // })
      // $("#messages").prepend(
      //   $("<p></p").text(new Date().toLocaleString() + " " + msg))
    },

    clickSetBuffer: function () {
      let that = this
      var key = "testBuffer"
      var value = new Date()
      ZteAgent.setBufferValue(key, value, function (isucc, errcode) {
        if (!isucc) {
          that.addMessages("设置缓存失败 " + errcode, 'error', 'error')
        }
        else {
          that.addMessages("设置缓存" + key + "成功!val:" + value)
        }
      })
    },

    clickgetByuffer: function () {
      let that = this
      var key = "testBuffer"
      var value = new Date()
      ZteAgent.getBufferValue(key, function (val) {
        if (!val) {
          that.addMessages("获取缓存key：" + key + " 失败", 'error')
        }
        else {
          that.addMessages("获取缓存" + key + "成功!val：" + val)
        }
      })
    },

    /**
     * 注册座席事件
     */
    registerAgentEvents: function () {
      this.registerAgentEventsIds = []
      let onCTIAgentStateChangedId = ZteAgent.regEvent("onCTIAgentStateChanged", this.onCTIAgentStateChanged)
      this.registerAgentEventsIds.push(onCTIAgentStateChangedId)

      let onStateChangedId = ZteAgent.regEvent("onStateChanged", this.onStateChanged)
      this.registerAgentEventsIds.push(onStateChangedId)

      let onRingingId = ZteAgent.regEvent("onRinging", this.onRinging)
      this.registerAgentEventsIds.push(onRingingId)
      let onTalkingId = ZteAgent.regEvent("onTalking", this.onTalking)
      this.registerAgentEventsIds.push(onTalkingId)
      let onReleaseId = ZteAgent.regEvent("onRelease", this.onRelease)
      this.registerAgentEventsIds.push(onReleaseId)

      let onRecordId = ZteAgent.regEvent("onRecord", this.onRecord)
      this.registerAgentEventsIds.push(onRecordId)

      // let onRecordEventId = ZteAgent.regEvent("onRecordEvent", this.onRecordEvent)
      // console.log('onRecordEventId', onRecordEventId)
      // this.registerAgentEventsIds.push(onRecordEventId)

      let onPlayEndId = ZteAgent.regEvent("onPlayEnd", this.onPlayEnd)
      this.registerAgentEventsIds.push(onPlayEndId)

      let onTransferedId = ZteAgent.regEvent("onTransfered", this.onTransfered)
      this.registerAgentEventsIds.push(onTransferedId)
      let onSingleTransferedId = ZteAgent.regEvent("onSingleTransfered", this.onSingleTransfered)
      this.registerAgentEventsIds.push(onSingleTransferedId)
      let onSnapShotCallId = ZteAgent.regEvent("onSnapShotCall", this.onSnapShotCall)
      this.registerAgentEventsIds.push(onSnapShotCallId)
      let onReturnFromIVRId = ZteAgent.regEvent("onReturnFromIVR", this.onReturnFromIVR)
      this.registerAgentEventsIds.push(onReturnFromIVRId)
      let onConsultBackId = ZteAgent.regEvent("onConsultBack", this.onConsultBack)
      this.registerAgentEventsIds.push(onConsultBackId)
      let onShareStartId = ZteAgent.regEvent("onShareStart", this.onShareStart)
      this.registerAgentEventsIds.push(onShareStartId)
      let onShareStopId = ZteAgent.regEvent("onShareStop", this.onShareStop)
      this.registerAgentEventsIds.push(onShareStopId)
      let onShareTypeChangeId = ZteAgent.regEvent("onShareTypeChange", this.onShareTypeChange)
      this.registerAgentEventsIds.push(onShareTypeChangeId)


      // 被强制操作事件通知
      let onForceBusyId = ZteAgent.regEvent("onForceBusy", this.onForceBusy) // 被强制示忙
      this.registerAgentEventsIds.push(onForceBusyId)
      let onForceIdleId = ZteAgent.regEvent("onForceIdle", this.onForceBusy) // 被强制示闲
      this.registerAgentEventsIds.push(onForceIdleId)
      let onForceOutId = ZteAgent.regEvent("onForceOut", this.onForceOut)   // 被强制签出
      this.registerAgentEventsIds.push(onForceOutId)

      let onBeInterceptedId = ZteAgent.regEvent("onBeIntercepted", this.onBeIntercepted)   // 呼叫被拦截
      this.registerAgentEventsIds.push(onBeInterceptedId)


      let onFailCause18XId = ZteAgent.regEvent("onTerminalFail", this.onFailCause18X)
      this.registerAgentEventsIds.push(onFailCause18XId)

      let onCtiReportId = ZteAgent.regEvent("onCtiReport", this.onCtiReport)
      this.registerAgentEventsIds.push(onCtiReportId)

    },
    unregEvents: function () {
      if (this.registerAgentEventsIds.length > 0) {
        this.registerAgentEventsIds.forEach(id => {
          try {
            ZteAgent.unregEvent(id)
          } catch (err) {
            console.log('unregEvent error', err)
          }
        })
      }
    },
    callPhone: function (data) {
      this.calleeNumber = data.number
      this.type = data.category
      this.clickMakeCall()
    },
    initDom: function (init) {
      // this.buildBtns()
      this.unregEvents()
      this.registerAgentEvents()
      let that = this
      if (init) {
        this.clickBtnSignIn()
      } else {
        this.$Modal.confirm({
          title: '提醒',
          content: '<p>请确认是否上线话务工作台？</p><p>若不上线，稍候可在话务面板中手动上线</p>',
          okText: '上线',
          cancelText: '稍后处理',
          onOk: () => {
            that.clickBtnSignIn()
          }
        })
      }
    },
  },
  beforeDestroy () {
    this.logOut()
    this.unregEvents()
  },
  beforeMount () {
    let that = this
    this.currentUserIno()

  },
}
</script>
<style lang="less" scoped>
.zteContainer {
  width: 100%;
  min-width: 240px;
  max-width: 360px;
  background-color: #fff;
  overflow: hidden;
  min-height: fit-content;
  height: 100%;

  .ztePanel {
    width: 100%;
    height: 100%;
    overflow: hidden;
    border: 1px solid #e9e9e9;
    border-radius: 5px;

    box-shadow: 0 0 1px #ebebeb, 0 8px 16px #00000014;

    .ztePanelHeader {
      padding: 10px;
      background: linear-gradient(#e7f1ff93 12%, #f6f6fb0c 99%, #f7f7fb00 100%);

      .lineHeader {
        display: flex;
        justify-content: space-between;
        align-content: center;

        .title {
          font-weight: 600;
          font-size: 1rem;
        }

        .titleBtns {
          font-weight: 600;
          font-size: 1.2rem;
        }
      }

      > .lineHeader:not(:first-child) {
        margin-top: 10px;
      }

      .leftH {
        align-items: center;
        display: flex;
      }

      .centerH {
        display: flex;
        align-items: center;
        padding-right: 10px;
      }

      .rightH {
      }
    }
    .ztePanelBody {
      min-height: 420px;
      overflow: hidden;
      border-top: 1px solid #e9e9e9;
      padding: 10px;

      .numberPanel,
      .hisPanel {
        height: 100%;
        overflow: hidden;
      }

      .phoneContainer {
        padding-top: 10px;

        .line {
          display: flex;
          justify-content: center;
          align-items: center;

          .numBtn {
            cursor: pointer;
            background-color: #e8eaec;
            font-size: 1.4rem;
            font-weight: 600;
            border-radius: 50%;
            text-align: center;
            line-height: 3rem;
            width: 3rem;
            height: 3rem;
            margin: 8px 10px;
            user-select: none;
          }
          .numBtn:hover {
            background-color: #5cadff;
            color: #fff;
          }

          .numBtn.disabled {
            cursor: not-allowed;
            background-color: #f7f7f7;
            color: #c5c8ce;
          }
        }
      }

      .hisPanel {
        display: flex;
        flex-direction: column;

        .historyRecordList {
          flex-grow: 1;
          overflow-y: auto;
          overflow-x: hidden;
        }
      }

      .phoneBtns {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;

        > div {
          margin: 0 6px;
          // flex: 1;
          width: 56px;
        }
      }

      .historyHeader {
        cursor: default;
        user-select: none;
        display: flex;
        // align-items: center;

        .backBtn {
          cursor: pointer;
          margin-right: 6px;
          font-size: 1.1rem;
        }
      }

      .loadingC {
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .historyRecordList {
        padding: 10px;
        min-height: 200px;
        .ivu-timeline-item {
          padding: 0;
        }

        .time {
          font-size: 0.85rem;
          font-weight: bold;
        }
        .content {
          font-size: 12px;
        }

        .historyRecord {
          border-bottom: 1px dashed #e9e9e9;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 6px 0;
          cursor: default;

          .historyRecordTitle {
            display: flex;
            align-items: center;
            font-size: 1rem;
          }

          .historyRecordTime {
            color: #999;
            font-size: 12px;
          }

          .historyRecordBtns {
            display: flex;
            align-items: center;
            .callBtn {
              background: #19be6b;
              font-size: 1rem;
              cursor: pointer;
              color: #fff;
              width: 1.6rem;
              border-radius: 5px;
              text-align: center;
            }

            .moreBtn {
              font-size: 1.2rem;
              color: #888;
              cursor: pointer;
            }
          }
        }
      }

      .nodata {
        text-align: center;
        line-height: 200px;
      }

      .ztePanelOff,
      .ztePanelWel,
      .ztePanelOnline {
        background-image: url(./zte/images/bgOff.png);
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        width: 80%;
        height: 220px;
        margin: 0 auto;
        position: relative;
        margin-bottom: 1rem;

        p {
          text-align: center;
          left: 0;
          right: 0;
          bottom: 0;
          position: absolute;
          font-weight: 500;
          color: #888;
        }
      }

      .ztePanelWel {
        background-image: url(./zte/images/welcome.png);
      }

      .ztePanelOnline {
        background-image: url(./zte/images/bgOnline.png);
      }

      .telPanelHeader {
        text-align: center;
        font-size: 0.9rem;
        color: #888;
      }

      .telNumber {
        margin: 10px;
        text-align: center;
        font-weight: 500;
        font-size: 1.4rem;
      }

      .telTime {
        text-align: center;
        font-weight: 400;
        font-size: 0.9rem;
      }

      .telRingInfo {
        > div {
          display: flex;
          line-height: 2rem;
          justify-content: space-between;
          align-items: center;

          color: #999;
          font-size: 0.8rem;
        }
      }

      .btnContainer {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .answerBtn {
        text-align: center;
        margin: 1rem;
      }

      .btnDesc {
        margin-top: 10px;
      }
    }

    .logContianerBody {
      padding: 10px 10px;
      margin-bottom: 10px;
      max-height: 200px;
      overflow-y: auto;
    }
  }
}

.statusMenu,
.leftH {
  user-select: none;

  .status {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 4px;
    background-color: gray;
    border-radius: 50%;
  }

  .status.online {
    background-color: #19be6b;
  }

  .status.offline {
    background-color: #c5c8ce;
  }

  .status.idle {
    background-color: #19be6b //#2d8cf0;;
  }

  .status.busy {
    background-color: #ff9900;
  }
}
</style>

<style lang="less">
.centerH {
  .ivu-input {
    border: none;
    background-color: transparent;
  }

  .ivu-input:focus {
    box-shadow: none;
  }
}

.statusIcon {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #2d8cf0;
}

.statusIcon.error {
  background-color: #ed4014;
}

.statusIcon.success {
  background-color: #19be6b;
}
</style>